import React from 'react';
import { Reveal } from '../ui/Reveal';
import { NUDOS_IMG, NUDOS } from '../../data/retiro';
export function Nudos() {
  return <section className="w-full px-5 py-24 sm:px-8 sm:py-32" style={{
    backgroundColor: 'rgba(176,146,191,0.08)'
  }} data-id="element-213" data-mp="2n2r5zdpt9gj5">
      <div className="mx-auto grid max-w-7xl items-center gap-12 md:grid-cols-2 md:gap-16" data-id="element-214" data-mp="2x1qcapn3t02z">
        <Reveal data-id="element-215" data-mp="29c5h98doecdc">
          <div className="relative overflow-hidden rounded-[2rem]" data-id="element-216" data-mp="29bmb0oxe1cf5">
            <img src={NUDOS_IMG} alt="Mujer sentada en un muelle de madera frente a la laguna al amanecer" className="aspect-[4/3] w-full object-cover" data-id="element-217" data-mp="299t2f437si4i" />
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-218" data-mp="2eaywb58m2bfm">
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.28em]" style={{
          color: 'var(--glossygrape)'
        }} data-id="element-219" data-mp="2e9nu39utdbqm">
            <span className="h-px w-8" style={{
            background: 'var(--glossygrape)'
          }} data-id="element-220" data-mp="1lmb7izonl3xb" />
            Los nudos invisibles
          </span>
          <h2 className="mt-5 font-heading text-3xl font-light leading-tight sm:text-4xl" style={{
          color: 'var(--ink)'
        }} data-id="element-221" data-mp="15hgc38u5lu4c">
            Este año movió todo… y por eso aparecen los nudos
          </h2>
          <p className="mt-5 text-base leading-relaxed" style={{
          color: 'rgba(42,36,32,0.72)'
        }} data-id="element-222" data-mp="ik4z65t8ytiw">
            Cuando se rompen los patrones de "aguantar" y "controlar", surge la
            pregunta real: ¿cómo salir del estancamiento, el cansancio y el
            miedo? Este año ha sido tan extraño que apenas alcanza el lenguaje
            para nombrarlo.
          </p>

          <ul className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-223" data-mp="2311aonj7tf0l">
            {NUDOS.map(n => <li key={n.titulo} className="rounded-2xl border bg-white/70 p-5" style={{
            borderColor: 'rgba(176,146,191,0.35)'
          }} data-id="element-224" data-mp="27w6w7l8pgro5">
                <p className="font-medium" style={{
              color: 'var(--ink)'
            }} data-id="element-225" data-mp="1s824alvgydkd">
                  {n.titulo}
                </p>
                <p className="mt-1 text-sm leading-relaxed" style={{
              color: 'rgba(42,36,32,0.7)'
            }} data-id="element-226" data-mp="ziv4ljka3hxj">
                  {n.texto}
                </p>
              </li>)}
          </ul>

          <blockquote className="mt-8 border-l-2 pl-5 font-heading text-lg font-light italic leading-relaxed" style={{
          borderColor: 'var(--glossygrape)',
          color: 'var(--ink)'
        }} data-id="element-227" data-mp="14ir6nd9f0zag">
            🧶 La transformación empieza donde dejas de empujar y comienzas a
            desenredar sin lastimar.
          </blockquote>
        </Reveal>
      </div>
    </section>;
}